import recordEvent from 'platform/monitoring/record-event';
import PropTypes from 'prop-types';
import React from 'react';
import content from '../../locales/en/content.json';

export const EXIT_APPLICATION_HREF =
  '/family-and-caregiver-benefits/health-and-disability/champva/';

export const buildExitEvent = location => ({
  event: 'nav-exit-application',
  form: '10-10d-extended',
  location,
});

const ExitApplicationLink = ({ location }) => (
  <va-link-action
    text={content['exit-application--link-text']}
    href={EXIT_APPLICATION_HREF}
    onClick={() => recordEvent(buildExitEvent(location))}
  />
);

ExitApplicationLink.propTypes = {
  location: PropTypes.string.isRequired,
};

export default ExitApplicationLink;
